import { render, staticRenderFns } from "./TibBannerDeleteModal.vue?vue&type=template&id=96dec1d4"
import script from "./TibBannerDeleteModal.vue?vue&type=script&lang=js"
export * from "./TibBannerDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports